import React from 'react';
import PropTypes from 'prop-types';
import {
  LuArrowLeftRight, LuBuilding2, LuCalendarRange, LuCreditCard, LuFileText, LuLandmark, LuMessageSquareText, LuPencil, LuTags,
} from 'react-icons/lu';
import DetailPane from '../../../../components/data/DetailPane';
import useBankAccountText from '../bankAccountText';
import { AccountStatusBadge } from './BankAccountCell';

/**
 * The selected bank account: company, IBAN (copyable), status, every field
 * of the record and "Düzenle". Docked beside the table on wide screens, a
 * drawer otherwise.
 */
const BankAccountDetailPane = ({ docked, height, account, position, onPrev, onNext, onClose, onEdit }) => {
  const { label } = useBankAccountText();
  const paneLabel = label('panel.label');

  if (!account) return <DetailPane docked={docked} height={height} open={false} label={paneLabel} onClose={onClose} />;

  const field = (key, icon, extra = {}) => ({ key, icon, label: label(`fields.${key}`), value: account[key] || '-', ...extra });

  return (
    <DetailPane
      docked={docked}
      height={height}
      open
      label={paneLabel}
      heading={label('panel.heading')}
      position={position}
      contentKey={account.id}
      identity={{
        avatar: <LuLandmark aria-hidden="true" className="tw-h-7 tw-w-7" />,
        gradient: 'tw-from-sky-400 tw-to-blue-600 tw-shadow-blue-500/30',
        title: account.firma || '-',
        subtitle: account.sube || undefined,
        badges: <AccountStatusBadge status={account.durum} />,
      }}
      actions={[
        { key: 'edit', label: label('panel.edit'), icon: LuPencil, tint: 'blue', onClick: onEdit },
      ]}
      details={[
        field('hesapNo', LuCreditCard, { copyable: Boolean(account.hesapNo) }),
        field('sube', LuBuilding2),
        field('dosyaAciklama', LuFileText),
        field('odemeKesinti', LuArrowLeftRight),
        field('odemeTuru', LuTags),
        field('odemeAciklama', LuMessageSquareText),
        field('odemeDonemi', LuCalendarRange),
      ]}
      onPrev={onPrev}
      onNext={onNext}
      onClose={onClose}
    />
  );
};

BankAccountDetailPane.propTypes = {
  docked: PropTypes.bool,
  height: PropTypes.number,
  account: PropTypes.object,
  position: PropTypes.shape({ index: PropTypes.number, total: PropTypes.number }),
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default BankAccountDetailPane;
